module["exports"] = [
  "#{last_name} #{first_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/name/name.js
// module id = 2462
// module chunks = 2